import { ATTRIBUTE_LABELS } from "../../shop/utils/scoreFormatter";

export const EMPTY_SHOP_DETAILS = { localName: "", qualityTags: "", attributes: [], badge: "" };

/** Platform product -> form values. */
export const fromPlatformProduct = (p) => ({
  localName: p?.localName ?? "",
  qualityTags: (p?.qualityTags ?? []).join(", "),
  attributes: p?.attributes ?? [],
  badge: p?.badge ?? "",
});

/** Form values -> PATCH /products/:id body (empty fields are cleared). */
export const toShopDetailsBody = (form) => ({
  localName: form.localName.trim() || null,
  qualityTags: form.qualityTags
    .split(/[,•]/)
    .map((t) => t.trim())
    .filter(Boolean)
    .slice(0, 8),
  attributes: form.attributes,
  badge: form.badge.trim() || null,
});

/**
 * What the customer shop shows besides nutrition: local name, quality line,
 * pack attributes (icons and shop filters) and the card badge. Saved on the
 * platform product; LOW_GI and GLUTEN_FREE are regulated claims.
 */
function ShopDetailsFields({ value, onChange, disabled }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const toggle = (code) =>
    set({
      attributes: value.attributes.includes(code)
        ? value.attributes.filter((a) => a !== code)
        : [...value.attributes, code],
    });

  return (
    <fieldset disabled={disabled} className="pe-grid">
      <label className="nutri-field">
        <span>Local name</span>
        <input
          className="form-control"
          lang="te"
          value={value.localName}
          maxLength={200}
          placeholder="e.g. కందిపప్పు (taken from the name if blank)"
          onChange={(e) => set({ localName: e.target.value })}
        />
      </label>
      <label className="nutri-field">
        <span>Card badge</span>
        <input
          className="form-control"
          value={value.badge}
          maxLength={30}
          placeholder="e.g. Best Seller"
          onChange={(e) => set({ badge: e.target.value })}
        />
      </label>
      <label className="nutri-field pe-span2">
        <span>Quality line (comma separated, up to 8)</span>
        <input
          className="form-control"
          value={value.qualityTags}
          placeholder="Premium Quality, Unpolished, Natural, 100% Pure"
          onChange={(e) => set({ qualityTags: e.target.value })}
        />
      </label>
      <div className="nutri-field pe-span2">
        <span>Pack facts (shown as icons and used as shop filters)</span>
        <div className="d-flex flex-wrap gap-3 mt-1">
          {Object.entries(ATTRIBUTE_LABELS).map(([code, label]) => (
            <label key={code} className="form-check form-check-inline m-0">
              <input
                type="checkbox"
                className="form-check-input"
                checked={value.attributes.includes(code)}
                onChange={() => toggle(code)}
              />
              <span className="form-check-label">{label}</span>
            </label>
          ))}
        </div>
        <small className="nutri-muted">Tick Low GI or Gluten Free only when the pack or a lab report states it.</small>
      </div>
    </fieldset>
  );
}

export default ShopDetailsFields;
